import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StatusContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;